import { useTranslation } from 'react-i18next';
import { mockCategories } from '@/mocks/articles';

interface Props {
  categorySlug: string;
}

export default function CategoryHero({ categorySlug }: Props) {
  const { t } = useTranslation();
  const category = mockCategories[categorySlug as keyof typeof mockCategories];

  if (!category) return null;

  const titles = {
    'star-scandal': {
      t1: t('category_starScandal_title1'),
      t2: t('category_starScandal_title2'),
      t3: t('category_starScandal_title3'),
    },
    'influencer-gossip': {
      t1: t('category_influencerGossip_title1'),
      t2: t('category_influencerGossip_title2'),
      t3: t('category_influencerGossip_title3'),
    },
    'black-material': {
      t1: t('category_blackMaterial_title1'),
      t2: t('category_blackMaterial_title2'),
      t3: t('category_blackMaterial_title3'),
    },
  }[categorySlug] || { t1: '', t2: '', t3: '' };

  return (
    <section className="w-full px-4 md:px-8 pt-28 pb-14 md:pt-32 md:pb-18 bg-background-50">
      <div className="max-w-[1280px] mx-auto text-center">
        <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300 text-foreground-700 text-xs font-medium mb-6 whitespace-nowrap">
          {category.name}
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight">
          {titles.t1}
          <br />
          {titles.t2}
          <br />
          {titles.t3}
        </h1>
      </div>
    </section>
  );
}